// Activated-ability dedupe signatures. Built-in entries from avatarRules
// describe abilities via a `_builtin` tag (the engine knows how to
// resolve them); parser-emitted entries describe the same abilities
// via the (cost, effect) shape. To avoid surfacing the same ability
// twice in the action menu, we map both sides onto a common signature
// and skip the parser entry when its signature matches a built-in's.
export function builtinSignature(entry) {
  if (entry?._builtin === 'tap_draw_spell') return 'tap|draw:spell';
  return null;
}

export function parsedSignature(entry) {
  const costs = (entry?.cost || []).map((c) => c.type).sort().join('+');
  const eff = entry?.effect?.[0];
  if (!eff) return null;
  if (eff.op === 'draw') return `${costs}|draw:${eff.args?.source || 'card'}`;
  return null;
}
